import React from 'react'

import Link from 'base/react/components/link'
import StoresFooter from 'base/components/visit_us/stores_footer'

export default function FooterNav() {
  return (
    <nav className="footer-nav">
      <ul>
        <li className="section" key="account">
          <h6 className="footer__column-heading">Account</h6>
          <ul>
            <li>
              <Link href="/account">Manage Account</Link>
            </li>
            <li>
              <Link href="/account/orders">Orders & Returns</Link>
            </li>
            <li>
              <Link href="/redeem">Redeem a Gift card</Link>
            </li>
          </ul>
        </li>
        <li className="section" key="company">
          <h6 className="footer__column-heading">Company</h6>
          <ul>
            <li>
              <Link href="/about">About</Link>
            </li>
            <li>
              <Link href="/sustainability">Environmental Initiatives</Link>
            </li>
            <li>
              <Link href="/factories">Factories</Link>
            </li>
            <li>
              <Link href="/dei">DEI</Link>
            </li>
            <li>
              <Link href="/careers">Careers</Link>
            </li>
            <li>
              <Link href="/international">International</Link>
            </li>
            <li>
              <Link href="/accessibility">Accessibility</Link>
            </li>
          </ul>
        </li>
        <li className="section" key="connect">
          <h6 className="footer__column-heading">Connect</h6>
          <ul>
            <li>
              <Link href="/help">Contact & FAQ</Link>
            </li>
            <li>
              <Link
                href="https://www.instagram.com/everlane"
                target="_blank"
                rel="noopener noreferrer"
              >
                Instagram
              </Link>
            </li>
            <li>
              <Link href="https://twitter.com/everlane" target="_blank" rel="noopener noreferrer">
                Twitter
              </Link>
            </li>
            <li>
              <Link href="/affiliates">Affiliates</Link>
            </li>
            <li>
              <Link href="/bulk">Bulk Orders</Link>
            </li>
          </ul>
        </li>
        <li className="section" key="visit">
          <h6 className="footer__column-heading">Visit Us</h6>
          <StoresFooter />
        </li>
      </ul>
    </nav>
  )
}
